import CataloguesService from '../../services/catalogues.service.js';

export const state = {
  catalogueData: null
};

export const mutations = {
  SET_CATALOGUE(state, catalogue) {
    state.catalogueData = catalogue;
  }
};

export const actions = {
  async getCatalogueData({ commit }) {
    const { selectedClientId } = this.state.profile.profileData;
    if (!selectedClientId) {
      return null;
    }
    const { data: catalogueData } = await CataloguesService.getClientCatalogueData(
      selectedClientId
    );
    commit('SET_CATALOGUE', catalogueData);
    return catalogueData;
  },
  async updateCatalogue({ commit, state, dispatch }, data) {
    const { body, notification } = data;
    try {
      const { data: updatedCatalogueData } = await CataloguesService.updateCatalogue(
        state.catalogueData.id,
        body
      );
      commit('SET_CATALOGUE', { ...state.catalogueData, ...updatedCatalogueData });
    } catch (error) {
      const errorNotification = {
        type: 'error',
        message: `feedback.errors.${notification.fieldToEdit}`,
        show: notification.show
      };
      dispatch('addNotification', errorNotification);
    }
  }
};
